import { FC } from "react";
import InfoTip from "../../ui/InfoTip";

export const LoadFailed: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <p className="text-sm text-red mb-3">
    Të dhënat nuk u ngarkuan dot.{" "}
    <button type="button" className="underline" onClick={onRetry}>
      Provo përsëri
    </button>
  </p>
);

// Which daily job writes the snapshot a tab reads; both run on Kosovo time (JobExtension.cs).
export type SnapshotJob = "tariff" | "competitors";

const JOB_RUN: Record<SnapshotJob, string> = {
  tariff:
    "Job-i ditor i tarifës e shkruan të parin në ekzekutimin e radhës (çdo ditë në 05:00, ora e Kosovës).",
  competitors:
    "Job-i ditor i çmimeve të konkurrentëve e shkruan të parin në ekzekutimin e radhës " +
    "(çdo ditë në 04:00, ora e Kosovës)."
};

// The daily job has not written a snapshot yet, or none exists on or before the day asked for.
export const NoSnapshot: FC<{ dated: boolean; job: SnapshotJob }> = ({ dated, job }) => (
  <div className="border border-gray-200 rounded-md py-16 px-4 bg-white flex justify-center">
    <div className="flex items-center gap-2">
      <h3 className="text-lg font-medium">
        {dated ? "Nuk ka snapshot deri në këtë datë" : "Nuk ka ende asnjë snapshot"}
      </h3>
      <InfoTip text={dated ? "Provo një datë më të vonë ose hiq filtrin e datës." : JOB_RUN[job]} />
    </div>
  </div>
);
